var zIndex = {
  neutral: 1,
  popover: 1000,
  backdrop: 2000,
  dialog: 3000,
  toast: 4000,
  tooltip: 5000
};

export { zIndex };
